import React, { useState, useEffect } from "react";
import { getOrganisation } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { CiEdit } from "react-icons/ci";
import { MdRemoveRedEye } from "react-icons/md";
import Modal from "./Model";
import UpdateModal from "./UpdateModel";
import DataTable from "../../../components/common/DataTable/DataTable";
import StatusCell from "../../../components/common/TableCells/StatusCell";
import Spinner from "../../Spin/Spinner";
import { render } from "ejs";

const OrgTable = () => {
  const [organisations, setOrganisations] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [updateModalData, setUpdateModalData] = useState(null);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);

  const token = useSelector((store) => store.userReducer.token);

  const viewData = (item, setModalData, setOpenModal) => {
    setModalData(item);
    setOpenModal(true);
  };

  const updateFunction = (item, setUpdateModalData, setIsUpdateModalOpen) => {
    setUpdateModalData(item);
    setIsUpdateModalOpen(true);
  };

  useEffect(() => {
    const fetchOrganisations = async () => {
      try {
        const response = await getOrganisation(token);
        if (response.success) {
          setOrganisations(response.data);
        } else {
          console.error("Failed to fetch organisations:", response.message);
        }
      } catch (error) {
        console.error("Error fetching organisations:", error);
      }
    };

    fetchOrganisations();
  }, [token]);

  const columns = [
      {
      key: "sno",
      header: "S.No",
      render: (_, index) => index + 1,
    },
    {
      header: "Org Name",
      key: "orgName",
      render: (row) => row.orgName || "-",
    },
    {
      header: "Org Domain URL",
      key: "orgDomainURL",
      render: (row) => row.orgDomainURL || "-",
    },
    {
      header: "Status",
      render: (row) => (
        <StatusCell status={row.isActive ? "ACTIVE" : "INACTIVE"} />
      ),
    },
    {
      header: "Update",
      render: (row) => (
        <CiEdit
          style={{
            width: "1.2rem",
            height: "1.2rem",
            cursor: "pointer",
          }}
          onClick={() =>
            updateFunction(row, setUpdateModalData, setIsUpdateModalOpen)
          }
        />
      ),
    },
    {
      header: "View",
      render: (row) => (
        <MdRemoveRedEye
          style={{
            width: "1.2rem",
            height: "1.2rem",
            cursor: "pointer",
          }}
          onClick={() => viewData(row, setModalData, setOpenModal)}
        />
      ),
    },
  ];

  return (
    <>
      <h1 style={{ marginBottom: "20px" }}>List of Organizations</h1>
      <div className="table-main-div">
        {organisations.length === 0 ? (
          <Spinner />
        ) : (
          <DataTable
            columns={columns}
            data={organisations}
            emptyMessage="No organizations found."
          />
        )}
      </div>

      {openModal && modalData && (
        <Modal modalData={modalData} setOpenModal={setOpenModal} />
      )}

      {isUpdateModalOpen && updateModalData && (
        <UpdateModal
          updateModalData={updateModalData}
          setIsUpdateModalOpen={setIsUpdateModalOpen}
          token={token}
        />
      )}
    </>
  );
};

export default OrgTable;
